import DeactivatedIcon from '@mui/icons-material/RemoveCircle';
import Skeleton from '@mui/material/Skeleton';
import CustomAvatar from 'common/components/CustomAvatar';
import useFlexBoxStyles from 'common/flexBox';
import useOnliveStyles from 'common/onliveStyles';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import ChannelsChipOver from './ChannelsChipOver';

const useChannelsStyles = makeStyles()((theme) => ({
    root: {
        '& .MuiInputBase-root': {
            background: '#FFFF',
            borderRadius: theme.spacing(2),
            [theme.breakpoints.up('xl')]: {
                height: 'auto',
                borderRadius: theme.spacing(2.5),
            },

            '& > fieldset': {
                borderColor: '#E2E2E2',
            },

            '& > input': {
                padding: theme.spacing(0, 1),
                height: '100%',
                fontSize: '12px',
                fontWeight: '500',
                position: 'relative',
                '&:focus': {
                    borderRadius: 5,
                },
                [theme.breakpoints.up('xl')]: {
                    fontSize: '14px',
                },
            },
        },
    },
    deactivated: {
        position: 'absolute',
        width: theme.spacing(2),
        height: theme.spacing(2),
        color: theme.palette.common.red,
        background: theme.palette.common.white,
        left: theme.spacing(-0.5),
        bottom: theme.spacing(-0.5),
        borderRadius: '50%',
    },
}));

export const ChannelsChipRender = ({ props, channel, loading, selected, tooltipLabels = true }) => {
    const { classes } = useChannelsStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const { classes: onlive } = useOnliveStyles();
    const { t } = useTranslation();

    if (loading) {
        return <Skeleton variant="circular" width={34} height={34} className={flexBox.marginLeft1} />;
    }

    let label = channel.name || 'unknown';
    if (!channel.activated) {
        label = `${label} - ${t('features.deactivated')}`;
    }

    return (
        <ChannelsChipOver
            {...props}
            selected={selected}
            className={onlive.borderIconButton}
            label={label}
            avatar={<CustomAvatar icon={channel.icon} name={channel.name} id={channel.id} />}
            tooltipLabel={tooltipLabels}
        >
            {channel.activated ? null : <DeactivatedIcon className={classes.deactivated} />}
        </ChannelsChipOver>
    );
};

export default ChannelsChipRender;
